export function blogArticleHover() {
  const blogArticles = document.querySelectorAll(".blog-article");

  blogArticles.forEach((listItem) => {
    listItem.addEventListener("mouseover", () => {
      listItem.classList.add("active");
    });

    listItem.addEventListener("mouseout", () => {
      blogArticles.forEach((item) => {
        item.classList.remove("active");
      });
    });
  });
}
